<template>
    <div class="_content">
        <!-- 权限说明 -->
        <div class="top_bar">
            <i @click="handleClick(tabList1[0])" >查看店长和员工的区别></i>
        
        
        </div>
        <!-- 内容 -->
        <div class="management_content" v-if="this.userRole === '老板' || this.userRole === '店长' ">
            <!-- 操作内容界面 -->
            <div class="card">
                <div class="title">              
                    <span>姓名</span>
                    <span>账号</span>
                    <span>状态</span>
                    <span>操作</span>
                </div>
                <!-- 老板界面 -->
                <div class="cont" v-if="this.userRole === '老板'" key="1"> 
                    <van-cell
                    v-for="(item, index) in UserManagementData || ''"
                    :key="index"
                    class="management_list"
                    >
                        <i  v-if="item.userName">
                            <span v-if="item.role === '老板'"  class="tip_boss">
                                {{item.role}}
                            </span>
                            <span v-else-if="item.role === '店长'"  class="tip_manager">
                                {{item.role}}
                            </span>
                            <span v-else class="tip_staff">
                                {{item.role}}
                            </span>
                            {{item.userName}}
                        </i>
                        <i>{{item.phone}}</i>
                        <i>{{item.status}}</i>
                        <i class="user_management_alter">
                            <img 
                            src="@/imgs/operation.png"
                            alt=""
                            @click="alterUser($event,index)"
                            >
                        </i>
                    </van-cell>
                </div>
                <!-- 店长界面 -->
                <div class="cont" v-else-if="this.userRole === '店长'" key="2"> 
                    <van-cell
                    v-for="(item, index) in UserManagementData"
                    :key="index"
                    class="management_list"
                    >
                        <i>
                            <span v-if="item.role === '老板'"  class="tip_boss">
                                {{item.role}}
                            </span>
                            <span v-else-if="item.role === '店长'"  class="tip_manager">
                                {{item.role}}
                            </span>
                            <span v-else class="tip_staff">
                                {{item.role}}
                            </span>
                            {{item.userName}}
                        </i>
                        <i>{{item.phone}}</i>
                        <i>{{item.status}}</i>
                        <i v-if="item.role === '老板'">——</i>
                        <i v-else class="user_management_alter">
                            <img 
                                src="@/imgs/operation.png"
                                alt=""
                                @click="alterUser($event,index)"
                            >
                        </i>
                    </van-cell>
                </div>
                <!-- 员工界面 -->
                <van-empty image="error" v-else-if="this.userRole === '员工' " description="员工权限不足" key="3"/>
            </div>
            <!-- 弹出选项 -->
            <van-action-sheet 
                v-if="this.UserManagementData[this.alterUserIndex]"
                v-model="show"
                :title=" this.alterUserIndex !== null ? '编辑账号-' + this.UserManagementData[this.alterUserIndex].userName : '编辑账号' "
                :round="false"
                cancel-text="取消编辑"
            >
                <div
                v-if="userStatus==='禁用' "
                    @click="userStatus==='禁用' ? onSelect1(tabList3[0], $event) : '' " 
                    class="alter_select"
                >
                    启用
                </div>
                <div 
                    v-if="userStatus==='启用'"
                    @click="userStatus==='启用' ? onSelect2(tabList3[0], $event) : '' " 
                    class="alter_select"
                >
                    禁用
                </div>
                <div @click="onSelect3(tabList3[0])" class="alter_select">删除</div>
            </van-action-sheet>
            <!-- 添加账号 -->
            <van-button 
                @click="handleClick(tabList2[0])"
                class="user_management_btn" 
                color="rgb(25,137,250)" 
                v-if="this.userRole === '老板' || this.userRole === '店长' "
                size="large" type="info">+新增账号
            </van-button>
        </div>
       
        <van-empty 
            image="error" 
            description="权限不够或网络错误" 
            v-if="this.userRole === '店员' || this.userRole === '' "
        />
    </div>
</template>
<script>
import config from '@/configs/config'
import { Dialog, CollapseItem } from 'vant'
export default {
    data() {
        return {
            UserManagementData: {},
            show: false, // 选择框显示隐藏
            alterUserIndex: null, // 当前修改用户的下标 点击改变
            tabList1: [{
			name: '员工权限',
			url: '/pages/accountAccessPic/index'
            }],
            tabList2: [{
			name: '新增账户',
			url: '/pages/addAccessUser/index'
            }],
            tabList3: [{
			name: '员工管理',
			url: '/pages/userManagement/index'
            }],
            userPhone: '',
            shopId: '',
            userId: '',
            userName: '默认',
            userRole: '',
            userStatus: ''
        }
    },
    created() {
        this.getUserManagementInfo()
    },
    // mounted() {
    //     if (window.history && window.history.pushState) {
    //     // 向历史记录中插入了当前页
    //     // history.pushState(null, null, document.URL)
    //     window.addEventListener('popstate', this.userManagementGoBack, false)
    // 	}
    // },
    // destroyed() {
	// 	window.removeEventListener('popstate', this.userManagementGoBack, false)
	// },
    methods: {
        // userManagementGoBack () {
        //     console.log('点击了浏览器的返回按钮')
        //     window.location.href = '/pages/home/index'
		// },
        async getUserManagementInfo() {
            // 身份信息
            const roleData = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
            if (roleData && roleData.code === '200') {
                this.userRole = roleData.data.role
                this.shopId = roleData.data.shopId
            } else {
                tuhu.toast(roleData.message || '获取权限失败')
            }
            // 员工列表
            const data = await tuhu.fetch(`${config.apis.SELECT_USER_INFO}/${this.shopId}`)
            if (data && data.code === '200') {
                this.UserManagementData = data.data
                this.userStatus = data.data.status
            } else {
                tuhu.toast(data.message || '网络错误')
            }
        },
        // 当前操作的用户数据
        alterUser(e, index) {
            // 点击的元素下标 对标第几条数据
            this.alterUserIndex = index
            this.show = true
            // 点击修改操作后需要发送的数据
            this.userPhone = this.UserManagementData[index].phone
            this.userId = this.UserManagementData[index].userId
            this.userName = this.UserManagementData[index].userName
            this.userStatus = this.UserManagementData[index].status
        },
        // 三个操作按钮的点击事件
            // 启用
        onSelect1(item, e) {
            // 确认框
            Dialog.confirm({
            title: '启用账号确认',
            message: `确认启用账号-${this.userName}-${this.userPhone}吗？`
            })
            // 点击确认
            .then(async () => {
                let data = await tuhu.fetch(`${config.apis.SHOP_USER_UPDATE}`, {
                method: 'post',
                body: JSON.stringify({
                    'phone': this.userPhone,
                    'shopId': this.shopId,
                    'status': 1,
                    'userId': this.userId,
                    'userName': this.userName
                    })
                })
                if (data && data.code === '200') {
                    this.show = false
                    tuhu.toast(data.message || '操作成功')
                    this.getUserManagementInfo()
                } else {
                    tuhu.toast(data.message || '网络错误')
                }
            })
            // 点击取消
            .catch(() => {
            })
        },
            // 禁用
        onSelect2(item) {
            // 确认框
            Dialog.confirm({
            title: '禁用账号确认',
            message: `确认禁用账号-${this.userName}-${this.userPhone}吗？`
            })
            .then(async () => {
                let data = await tuhu.fetch(`${config.apis.SHOP_USER_UPDATE}`, {
                method: 'post',
                body: JSON.stringify({
                    'phone': this.userPhone,
                    'shopId': this.shopId,
                    'status': 0,
                    'userId': this.userId,
                    'userName': this.userName
                    })
                })
                if (data && data.code === '200') {
                    this.show = false
                    tuhu.toast(data.message || '操作成功')
                    this.getUserManagementInfo()
                } else {
                    tuhu.toast(data.message || '网络错误')
                }
            })
            .catch(() => {
            })
        },
            // 删除
        async onSelect3(item) {
            // 确认框
            Dialog.confirm({
            title: '删除账号确认',
            message: `确认删除账号-${this.userName}-${this.userPhone}吗？`
            })
            .then(async () => {
                let data = await tuhu.fetch(`${config.apis.SHOP_USER_UPDATE}`, {
                method: 'post',
                body: JSON.stringify({
                    'phone': this.userPhone,
                    'shopId': this.shopId,
                    'status': 2,
                    'userId': this.userId,
                    'userName': this.userName
                    })
                })
                if (data && data.code === '200') {
                    this.show = false
                    tuhu.toast(data.message || '操作成功')
                    this.getUserManagementInfo()
                } else {
                    tuhu.toast(data.message || '网络错误')
                }
            })
            .catch(() => {
            })
        },
        handleClick (item) {
		    tuhu.navigateTo({
			    url: item.url
            })
        },
        onPageBack () {
			this.getUserManagementInfo()
		}
    }
}
</script>
<style lang="less" scoped>
    @theme_blue:#1989fa;
    ._content{
        display: flex;
        flex-direction: column;
    }
    .management_content{
        display: flex;
        flex-direction: column;
    }
    .top_bar{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.75rem;
        i{
            color:#097DD4;
        }
    }
    .card{
        display: flex;
        flex-direction: column;
        border-radius: 5px;
        margin: 0 .5rem .5rem .5rem;
        .title{
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-style: normal;
            box-shadow: inset 0px -1px 1px -1px #333;
            padding: .5rem 1rem .5rem 2.5rem;

        }
        .cont{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;
            font-size: 14px;
            text-align: left;
            font-weight: 400;
            font-style: normal;
            color: #333;
            padding: .5rem;
        }
    }
    // div
    /deep/.management_list >.van-cell__value{
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: flex-start;
        align-items: center;
        font-size: .7rem; 
        width: 100%;
        height: 100%;
        i:nth-child(1) {
            flex: 2.9;
            >span{
                font-size: .6rem; 
            }
        }
        i:nth-child(2) {
            flex: 3.2;
        }
        i:nth-child(3) {
            flex: 2.4;
        }
        i:nth-child(4) {
            flex: 1.5;
                text-align: center;
        }
    }
    // i
    .management_list{
        padding-right: 0;
        padding-left: .5rem;
    }
    .tips{
        color: #fff;
        font-style:normal;
        padding: .15rem;
        border-radius: .1rem;
    }
    .tip_boss{
        .tips;
        background: rgb(132,0,255);
    }
    .tip_manager{
        .tips;
        background: @theme_blue;
    }
    .tip_staff{
        .tips;
        background: rgb(9,125,212);
    }
    .user_management_btn{
        width: 9rem;
        height: 2.25rem;
        .van-button__text{
        color: #fff;
        }
    }
    .user_management_alter{
        display: inline-block;
        img{
            width: 1.3rem;
            height: 1rem;
            margin: 0 auto;
        }
    }
    .alter_select{
        width: 100%;
        height: 2.5rem;
        line-height:2.5rem;
        text-align: center;
        box-shadow: 0px -1px 1px -1px #eee;
        color: rgb(241, 41, 41);
        font-size: .8rem;
    }
    .alter_select:nth-child(1) {
        color: @theme_blue;
    }    
    .alter_select:active {
        background: #eee;
    }
    .van-action-sheet__header{
        background: rgb(215, 215, 215);
    }
</style>


// WEBPACK FOOTER //
// src/pages/userManagement/index.vue